/** Lightweight className combiner. */
export function cn(...parts: (string | undefined | false | null)[]): string {
  return parts.filter(Boolean).join(" ");
}
